import type { IconProp } from '@fortawesome/fontawesome-svg-core'
import {
  faAmazon,
  faApple,
  faBandcamp,
  faDeezer,
  faGooglePlay,
  faItunes,
  faNapster,
  faSoundcloud,
  faSpotify,
  faVimeo,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons'
import { faBoltLightning } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from 'react-router-dom'
import type { StreamingLinksProps } from '../../../types/portfolio'

const lookup_table = {
  spotify: faSpotify,
  bandcamp: faBandcamp,
  googleplay: faGooglePlay,
  apple: faApple,
  itunes: faItunes,
  soundcloud: faSoundcloud,
  disco: faBoltLightning,
  deezer: faDeezer,
  youtube: faYoutube,
  amazon: faAmazon,
  napster: faNapster,
  vimeo: faVimeo,
} as const satisfies Record<string, IconProp>

export function StreamingLinks({ links, className }: StreamingLinksProps) {
  if (links.length === 0) return null

  return (
    <ul id="streaming-links" className={className ?? 'flex justify-start'}>
      {links.map((link) => {
        const key = link.name as keyof typeof lookup_table
        const icon = lookup_table[key]

        return (
          <li
            key={link.name}
            className={`text-neutral-500 transition-all duration-200 hover:scale-110 hover:text-neutral-900 dark:text-neutral-400 dark:hover:text-neutral-100 ${link.name}`}
          >
            <Link
              aria-label={link.name}
              to={link.url}
              target="_blank"
              rel="noreferrer"
              className="social-link"
            >
              <button
                aria-label={link.name}
                className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md"
              >
                <FontAwesomeIcon size="lg" icon={icon} inverse />
              </button>
            </Link>
          </li>
        )
      })}
    </ul>
  )
}
